module.exports = __webpack_public_path__ + "static/media/inktoberHauntedHouse.a2599196.gif";